import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 8h4","key":"svg-0"}],["path",{"d":"M21 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1","key":"svg-1"}],["path",{"d":"M12 8v8","key":"svg-2"}],["path",{"d":"M7 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0","key":"svg-3"}]]

const IconMathCtg = createReactComponent('outline', 'math-ctg', 'MathCtg', __iconNode);

export default IconMathCtg;